import { serviceGetAssociatedRoles } from "../services/AssociateEmployeesRole.service";

export const FETCH_INIT = "FETCH_INIT_EMPLOYEE";
export const FETCHED = "FETCHED_EMPLOYEE";
export const DELETE_ITEM = "DELETE_EMPLOYEE";

export function actionGetAssociatedEmpRole(index = 1, sorting = {}, filter = {},query_data) {
    const request = serviceGetAssociatedRoles({index,sorting, filter ,query_data: [query_data] });
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
         
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
            }
        })
    }
}

// export function actionDeleteAssociatedEmpRole(shift_id, id) {
//     const request = serviceDeleteAssociateEmp({ shift_id: shift_id, employee_id:id})
//     return (dispatch) => {
//         dispatch({type: DELETE_ITEM, payload: id})
       
//     }
//   }
